var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginPageMobileBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 976,
    height: 974,
    viewBox: "0 0 976 974",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M631.015 708.301C631.015 598.244 613.687 457.972 803.004 509.026C992.32 560.08 974.992 598.244 974.992 708.301C974.992 818.357 897.99 907.575 803.004 907.575C708.017 907.575 631.015 818.357 631.015 708.301Z",
    fill: "url(#paint0_radial_417_1154)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M675.668 115.37C703.723 43.1196 729.569 -7.18264e-06 796.059 4.74597e-07C862.55 8.13184e-06 916.451 51.6528 916.451 115.37C916.451 179.087 862.55 230.739 796.059 230.739C352.001 230.739 647.612 187.62 675.668 115.37Z",
    fill: "url(#paint1_radial_417_1154)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7177 46.1725C57.7177 -57.7143 197.642 46.1726 287.299 46.1726C424.591 46.1726 638.856 -57.7143 638.856 46.1725C638.856 150.059 493.798 236.334 326.073 252.8C238.466 261.401 172.704 218.699 57.7177 266.892C-11.7907 296.024 57.7176 103.448 57.7177 46.1725Z",
    fill: "url(#paint2_radial_417_1154)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M305.648 331.149C300.057 266.857 681.405 252.356 705.544 252.356C800.53 252.356 974.992 269.905 974.992 379.961C974.992 490.018 800.53 469.81 705.544 469.81C610.557 469.81 313.32 419.361 305.648 331.149Z",
    fill: "url(#paint3_radial_417_1154)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M578.284 477.863C635.907 507.476 611.688 706.924 469.429 772.107C336.71 832.919 227.863 786.851 192.933 684.507C185.127 590.337 334.273 675.385 422.603 634.912C461.987 616.867 378.516 550.367 395.552 514.055C416.723 468.927 536.638 456.46 578.284 477.863Z",
    fill: "url(#paint4_radial_417_1154)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3377 534.166C17.3377 395.11 78.9432 282.383 154.938 282.383C230.932 282.383 356.941 427.983 356.941 567.039C356.941 706.095 111.468 384.132 154.937 785.948C167.05 897.909 17.3377 673.222 17.3377 534.166Z",
    fill: "url(#paint5_radial_417_1154)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.78035 851.96C4.49653 819.036 134.993 904.388 154.721 839.849C181.971 750.705 267.735 899.597 508.618 808.114C575.258 782.806 640.674 810.006 644.17 851.959C647.666 893.912 611.805 914.371 517.165 923.76C140.879 930.272 1.78035 893.214 1.78035 851.96Z",
    fill: "url(#paint6_radial_417_1154)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_417_1154",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(803.003 708.301) rotate(-90) scale(199.275 171.988)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99C551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C5BA6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_417_1154",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(796.059 115.37) rotate(-90) scale(115.37 120.392)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.348958,
    stopColor: "#8A73DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99C551"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_417_1154",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(348.287 133.549) rotate(-90) scale(133.549 290.569)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE7233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C5BA6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_417_1154",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(627.064 361.812) rotate(-90) scale(109.456 347.927)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.302083,
    stopColor: "#3C5BA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A73DB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_417_1154",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(419.786 663.061) rotate(71.1548) scale(120.425 221.62)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#3C5BA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A73DB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_417_1154",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(158.534 548.841) rotate(-90) scale(266.459 141.196)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99C551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C5BA6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_417_1154",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(324.754 876.347) rotate(-94.2264) scale(66.1977 320.348)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE7233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C5BA6"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginPageMobileBackground);
export default __webpack_public_path__ + "static/media/Login Page _ Mobile Background.06cc0e23937170f328ce19ef75a8ad38.svg";
export { ForwardRef as ReactComponent };